import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Builds the `Authorization` header for the current authenticated user.
 *
 * Replaces the `custom_header` callback that was previously supplied to
 * `Amplify.configure({ API: { endpoints: [...] } })` in aws-amplify v4/v5.
 *
 * When there is no authenticated session the browser is redirected to the
 * login page and `null` is returned so callers can abort the request.
 */
export async function getAuthHeaders(): Promise<Record<string, string> | null> {
  try {
    const { tokens } = await fetchAuthSession();
    const idToken = tokens?.idToken?.toString();
    if (idToken) {
      return { Authorization: `Bearer ${idToken}` };
    }
  } catch (_e) {
    // No authenticated session.
  }

  window.location.assign('/login');
  return null;
}
